module.exports = __webpack_public_path__ + "static/img/9.d8cc7165.jpg";